module.exports = __webpack_public_path__ + "static/media/assess-feature.a1395468.svg";